import {BaseComponent, BaseProps, BasicStyles} from "react-vextensions";
import * as React from "react";

// todo: probably move to react-vcomponents
export const MDIcon = (props: {icon: string, size: number, width?: number | "auto", height?: number | "auto", iconSize?: number, style?} & BaseProps & React.JSX.IntrinsicElements["span"])=>{
	let {icon, size, iconSize, width, height, style, ...rest} = props;
	width = width ?? size;
	height = height ?? size;
	iconSize = iconSize ?? size;
	return (
		<span {...rest} className={`mdi mdi-${icon}`} style={{
			display: "inline-flex", width, height, fontSize: iconSize,
			...BasicStyles(props),
			...style
		}}/>
	);
};

/*import Icon from '@mdi/react';
import { mdiHeadDotsHorizontal } from '@mdi/js';
<Icon path={mdiHeadDotsHorizontal} size={1} />*/